import * as React from 'react'
import { CharacterSearch } from '@/components/character/character-search'
import { ReportSelection } from '@/components/character/report-selection'
import { AnalysisResults } from '@/components/analysis/analysis-results'
import { useAnalysisFlow } from '@/hooks/use-analysis-flow'

export const HomePage: React.FC = () => {
  const {
    step,
    character,
    report,
    fight,
    setCharacter,
    setFight,
    goToSearch,
    goToReports,
  } = useAnalysisFlow()

  return (
    <div className="container mx-auto px-4 py-8">
      {step === 'search' && (
        <div className="flex justify-center">
          <CharacterSearch 
            onCharacterSelect={setCharacter}
            className="w-full max-w-2xl"
          />
        </div>
      )}

      {step === 'reports' && character && (
        <ReportSelection
          character={character}
          onFightSelect={setFight}
          onBack={goToSearch}
        />
      )}

      {step === 'analysis' && character && report && fight && (
        <AnalysisResults
          character={character}
          report={report}
          fight={fight}
          onBack={goToReports}
        />
      )}
    </div>
  )
}